import {
  Avatar,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Snackbar1 from "../../../../components/ui/Snackbar";
import { ArrowLeft2 } from "iconsax-react";
import { useNavigate } from "react-router-dom";

export default function Profile({
  login,
  client,
  viewById,
  close_snack_bar,
  snackbar,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.background = "rgba(3, 22, 52, 0.1)";
    viewById(login.token, login.user_id);
  }, [viewById, login.token, login.user_id]);



  return (
    <div style={{ width: "100%" }}>
      <Grid>
        <Button
          variant="text"
          sx={{
            color: "#031634",
            textTransform: "none",
            "&:hover": { backgroundColor: "#e6f2ff" },
          }}
          onClick={() => navigate(-1)} // Navigate back
        >
          <ArrowLeft2 /> Back
        </Button>
      </Grid>
      <Grid container px={{ xs: 2, sm: 4, md: 5 }} justifyContent="center">
        <Grid item xs={12} md={10} lg={8}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 3, sm: 4, md: 5 },
              borderRadius: 4, // Higher border radius for premium feel
              backgroundColor: "#FFF",
              transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
              },
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} sm={4} textAlign="center">
                <Avatar
                  src={client?.allLinksByAdmin?.profileImage}
                  sx={{
                    width: { xs: 100, sm: 120, md: 150 },
                    height: { xs: 100, sm: 120, md: 150 },
                    border: "4px solid white",
                    boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    mx: "auto",
                    borderRadius: "50%",
                    "& img": { objectFit: "cover" }
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={8}>
                <Grid container spacing={3}>
                  {[
                    { label: "Name", value: login.name },
                    { label: "Username", value: login.username },
                    { label: "Mobile", value: `+91 ${login.mobile}` },
                    { label: "Industry", value: login.industry },
                    { label: "Email", value: login.email },
                  ].map((item) => (
                    <Grid item xs={12} sm={6} key={item.label}>
                      <Typography variant="caption" color="textSecondary" fontWeight={600} textTransform="uppercase" letterSpacing={1}>
                        {item.label}
                      </Typography>
                      <Typography variant="body1" fontWeight={500} color="textPrimary">
                        {item.value || "-"}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Snackbar1
        open={snackbar?.response_received}
        message={snackbar?.message}
        close_snack_bar={close_snack_bar}
      />
    </div>
  );
}
